import React from "react";
import styled from "styled-components";

import Findnovel from "../images/Findnovelglobal-0001.svg";
import Technologiesdetails from "../images/Nopointjustskimming-0001.svg";
import TechnologyAnalysis from "../images/Findrichanup-to-date-0001.svg";
import MapsTextImage from "../DesignTeam/MapsTextImage";
import MapImageText from "../DesignTeam/MapImageText";
import { RobotoFontWrapper } from "../IPWebsiteRedesign/RobotoFont";
import { ExploreResearchSolutions } from "../MarketAnalysis/ExploreResearchSolutions";
import { FinalBanner } from "../MarketAnalysis/FinalBanner";

const CookieWrap = styled.div`
  text-align: center;
  margin: 0 auto;
  margin-top: 0px;
`;
const TxtWrap = styled.div`
  width: 1055px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin: 0 auto;

  @media screen and (max-width: 767px) {
    width: auto;
  }
`;

export default function CookieCutterTechnologyAnalysis(props) {
  let contentArr = [
    "We smartly combine information from research journals, patents, and startups.",
  ];
  let contentArr1 = [
    "You are just a click away from a perfectly summarized profile of a technology or a company.",
  ];
  let contentArr2 = [
    "Ideapoke will pick up specifications, maturity and status of the tech from more varied sources than you can imagine.",
  ];
  return (
    <div>
      <RobotoFontWrapper>
        <CookieWrap>
          <MapsTextImage
            Heading="Find novel global technologies across research, emerging or stealth stages. All in one place"
            Content={contentArr}
            rightImg={Findnovel}
          ></MapsTextImage>
          <MapImageText
            Title="Find rich and up-to-date Technology and company profiles."
            Content={contentArr1}
            dImage={TechnologyAnalysis}
          ></MapImageText>
          <MapsTextImage
            Heading="No point just skimming news headlines about technologies and startups. The devil is in the details."
            Content={contentArr2}
            rightImg={Technologiesdetails}
          ></MapsTextImage>
        </CookieWrap>
        <ExploreResearchSolutions title={props.title}></ExploreResearchSolutions>
        <FinalBanner />

      </RobotoFontWrapper>

    </div>
  );
}
